import React, {useEffect} from 'react';
import instashellSetup from "./instashellSetup";
import InstashellApp from "./instashell/InstashellApp";
import ApplicationContextProvider from "./context/ApplicationContext";

const App = () => {

    useEffect(() => {
        document.querySelector('html').setAttribute('data-theme', localStorage.getItem('theme') || 'dark');
    }, []);

    return (
        <ApplicationContextProvider>
            <InstashellApp instashellSetup={instashellSetup}/>
        </ApplicationContextProvider>
    );

}

export default App;
